import { DataField } from './DataField';
import { DataFieldType } from './DataFieldType';
import { TelemetryEventValidator } from './TelemetryEventValidator';

export function makeBooleanDataField(name: string, value: boolean): DataField {
  return {
    name: name,
    dataType: DataFieldType.Boolean,
    value: value
  };
}

export function makeInt64DataField(name: string, value: number): DataField {
  TelemetryEventValidator.validateInt(value);
  return {
    name: name,
    dataType: DataFieldType.Int64,
    value: value
  };
}

export function makeDoubleDataField(name: string, value: number): DataField {
  return {
    name: name,
    dataType: DataFieldType.Double,
    value: value
  };
}
export function makeStringDataField(name: string, value: string): DataField {
  return {
    name: name,
    dataType: DataFieldType.String,
    value: value
  };
}
